import React from 'react'
import TimesheetModal from 'Components/Timesheets/TimesheetModal'
import PopupWrapper from 'Components/PopupWrapper/PopupWrapper'

const TicketTimesheetCreate = (props) => {
  const { isInvoiced, isReviewed, isReopened } = props

  const trigger = (
    <button
      className="button"
      disabled={(isReviewed || isInvoiced) && !isReopened}
      type="button"
    >
      New Timesheet Entry
    </button>
  )

  return (
    (isInvoiced || isReviewed) && !isReopened ? (
      <PopupWrapper
        trigger={<span>{trigger}</span>}
        options={
          {
            on: 'hover',
            closeOnDocumentClick: false,
            contentStyle: {
              padding: '0',
              borderRadius: '5px',
              width: 'auto',
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none'
            }
          }
        }
      >
        <div>
          This ticket has been already
          {isReviewed ? ' reviewed' : ''}
          {isInvoiced && isReviewed ? ' and' : ''}
          {isInvoiced ? ' invoiced' : ''}
          . Please re-open ticket to add new timesheet entry.
        </div>
      </PopupWrapper>
    )
      : (
        <TimesheetModal
          {...props}
          trigger={trigger}
          newTimesheet
        />
      )
  )
}

export default TicketTimesheetCreate
